import { render, staticRenderFns } from "./DataMonitoringStats.vue?vue&type=template&id=bb05efca&scoped=true"
import script from "./DataMonitoringStats.vue?vue&type=script&lang=js"
export * from "./DataMonitoringStats.vue?vue&type=script&lang=js"
import style0 from "./DataMonitoringStats.vue?vue&type=style&index=0&id=bb05efca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb05efca",
  null
  
)

export default component.exports